function checkRange(item, y) {
  //to check if the overlay::before was clicked
  var max = item.offset().top + item.outerHeight();
  var min = max - 130;

  return y >= min && y <= max;
}

export default checkRange;
